module.exports = __webpack_public_path__ + "img/snap_05.5406941c.png";